
<div class="body">

    <h1>Privacy Policy for Ekasi</h1>

    <h2>Introduction</h2>
    <p>Welcome to the privacy policy for Ekasi. This policy outlines how we collect, use, and protect your information when you use our app.</p>

    <h2>Information We Collect</h2>
    <h3>Device Information</h3>
    <p>We collect device-specific information such as the hardware model, operating system version, and unique device identifiers.</p>

    <h3>Location Information</h3>
    <p>We collect location information with your consent to provide location-based services.</p>

    <h3>Camera and Photos</h3>
    <p>We access your device's camera and photos with your consent to allow you to take and upload photos.</p>

    <h3>Audio</h3>
    <p>We access your device's microphone with your consent to allow you to record audio.</p>

    <h3>Contacts</h3>
    <p>We access your contacts with your consent to allow you to invite your friends to use our app.</p>

    <h2>How We Use the Information</h2>
    <ul>
        <li>To provide and improve our services.</li>
        <li>To offer personalized content.</li>
        <li>To process your inquiries and troubleshoot problems.</li>
    </ul>

    <h2>Third-Party Services</h2>
    <p>We may share your information with third-party services to help us provide our services and not for the third-party to provide their services to you.</p>

    <h2>Security</h2>
    <p>We take reasonable measures to protect your information.</p>

    <h2>Changes to This Policy</h2>
    <p>We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes.</p>

    <h2>Contact Us</h2>
    <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at eliemichael@mcsitech.com.</p>

</div>

